import { __decorate } from "tslib";
import { SlickComponentNgModule } from '@gn-audio/angularjs-components/slick';
import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';
import { ProductButtonsComponent } from './product-buttons/product-buttons.component';
import { ProductSelectComponent } from './product-select/product-select.component';
import { ProductSelectBlueparrottComponent } from './product-select-blueparrott/product-select-blueparrott.component';
import { EolInfoComponent } from './eol-info-spot/eol-info-spot.component';
import { CustomizerSpotController } from './customizer-spot/customizer-spot.controller';
import { ProductInformationSpotController } from './product-information-spot/product-information-spot.controller';
import { SupportDesignModule } from 'src/Foundation/Design/app';
var moduleId = 'gn.audio.support.customizer';
var legacyModuleId = moduleId + ".legcay";
module(legacyModuleId, [])
    .controller('CustomizerSpotController', CustomizerSpotController)
    .controller('ProductInformationSpotController', ProductInformationSpotController);
var CustomizerModule = (function () {
    function CustomizerModule() {
    }
    CustomizerModule = __decorate([
        NgModule({
            declarations: [
                ProductButtonsComponent,
                ProductSelectComponent,
                ProductSelectBlueparrottComponent,
                EolInfoComponent
            ],
            id: moduleId,
            imports: [SlickComponentNgModule.name, SupportDesignModule, legacyModuleId],
            providers: [],
        })
    ], CustomizerModule);
    return CustomizerModule;
}());
export { CustomizerModule };
